import React from 'react'
import Service from '../Service'

const WebDevelopment = () => {
    const title = 'Web Application Development'
    const description = 'Bug Resistance delivers modern, scalable web applications built with cutting-edge technologies. From responsive SPAs to complex enterprise platforms, our team leverages React, Next.js, Node.js, and cloud-native architectures to create robust web solutions that drive business growth and deliver exceptional user experiences.'
  return (
    <>
        <Service title={title} description={description} />
    </>
  )
}

export default WebDevelopment
